customElements.get('vat-checker');

const vat_regex = new RegExp(
  /^[A-Za-z]{2,4}(?=.{2,14}$)[-_\s0-9]*(?:[a-zA-Z][-_\s0-9]*){0,2}$/g
);

customElements.define(
  'vat-checker',
  class VatChecker extends HTMLElement {
    constructor() {
      super();
      this.API_URL = 'https://bioetiketten.activated-web.com/api/v1';
      // this.API_URL = 'https://replace-account-task-issues.trycloudflare.com/api/v1';
      this.vatInputTimeout = null;
      this.vatInput = this.querySelector('input[name="vat_id"]');
      this.vatInputAccount = this.querySelector('input[name="vat_id-account"]');
      console.log(this.vatInputAccount);
      this.inputContainer = () =>
        this.querySelector('.vat-checker__input-container');
      this.loader = `
        <div class="vat-checker__loader">
          <svg viewBox="22 22 44 44"><circle class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate css-14891ef" cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6"></circle></svg>
        </div>
      `;
      this.loading = false;
      this.message = () => this.querySelector('.vat-checker__message');
      this.checkoutButton = () => document.querySelector('button[name="checkout"]');

      this.data = this.getData();

      const hiddenInput = this.hiddenVatInput();
      // init hidden input and set values

      if (!hiddenInput.value) {
        hiddenInput.value = window.localStorage.getItem('vat_id');
      }
      if (this.vatInput) {
        this.vatInput?.addEventListener('input', this.handleVatInputChange);
        this.vatInput.value = hiddenInput.value;
      }

      const checkoutButton = this.checkoutButton();
      checkoutButton?.addEventListener('click', this.checkoutButtonClick);

      window.addEventListener('pageshow', () => {
        // check state of UI, etc.
        this.checkoutButton()?.classList.remove('working');
        this.renderMessage('', '');

        if (this.vatInput)
          this.handleVatInputChange({
            target: { value: this.hiddenVatInput().value },
          });
      });

      if (this.vatInputAccount) {
        this.saveButton = this.querySelector('#save-vat-button');
        this.deleteButton = this.querySelector('#delete-vat-button');

        this.saveButton.addEventListener('click', this.handleSaveVat);
        this.deleteButton.addEventListener('click', this.handleDeleteVat);
      }
    }

    handleSaveVat = () => {
      if (!this.vatInputAccount.value) return;
      this.startLoading();
      this.checkVatId(this.vatInputAccount.value);
    };

    handleDeleteVat = async () => {
      console.log('asdasd');
      if (!this.vatInputAccount.value || !this.data.customer.id) return;
      try {
        this.startLoading(this.deleteButton);
        const res = await fetch(
          `${this.API_URL}/check-vat/${this.data.customer.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        if (res.status !== 200) throw new Error(res.statusText);

        this.setHiddenInputValue('');
        this.vatInputAccount.value = '';
        document.querySelector('input[name="vat_id"]').value = '';

        this.renderMessage(
          this.data.shop.vatDeletedMessage,
          'success',
          this.deleteButton
        );
      } catch (error) {
        console.error(error);
        this.renderMessage(this.data.shop.generalError, 'error');
      }
    };

    handleVatInputChange = (e) => {
      console.log('handleVatInputChange');
      this.startLoading();

      clearTimeout(this.vatInputTimeout);
      this.vatInputTimeout = setTimeout(() => {
        const { value } = e.target;
        if (!value || value === '') {
          this.renderMessage('', '');
          this.setHiddenInputValue('');
          return;
        }
        if (value.match(vat_regex)) {
          this.checkVatId(value);
        } else {
          this.renderMessage(this.data.shop.wrongSyntax, 'error');
          this.setHiddenInputValue('');
        }
      }, 600);
    };

    getData = () => {
      const dataScript = document.getElementById('vat-checker-data');
      const data = dataScript === null ? null : JSON.parse(dataScript.text);

      return data;
    };

    hiddenVatInput = () => document.getElementById('vat-checker-hidden-input');
    setHiddenInputValue = (value) => {
      this.hiddenVatInput().value = value;
      window.localStorage.setItem('vat_id', value);
    };

    startLoading = () => {
      const el = this.inputContainer();
      el.classList.add('loading');
      if (this.vatInputAccount) {
        this.saveButton?.setAttribute('disabled', 'true');
        this.deleteButton?.setAttribute('disabled', 'true');
      } else {
        this.checkoutButton()?.setAttribute('disabled', 'true');
      }
      this.loading = true;
    };
    stopLoading = () => {
      const el = this.inputContainer();
      el.classList.remove('loading');
      if (this.vatInputAccount) {
        this.saveButton?.removeAttribute('disabled');
        this.deleteButton?.removeAttribute('disabled');
      } else {
        this.checkoutButton()?.removeAttribute('disabled');
      }
      this.loading = false;
    };

    renderMessage = (msg, type) => {
      this.message().innerHTML = `<span class="${type}">${msg}</span>`;
      this.stopLoading();
    };

    checkVatId = async (vat_id) => {
      const value = vat_id.replace(/\s/g, '').toUpperCase();
      if (!value) return;

      const savedVatId = window.localStorage.getItem('vat_id');
      const lastCheckDate = new Date(
        window.localStorage.getItem('vat_id:last_check')
      );
      const currentTime = new Date();
      if (savedVatId === value) {
        if (currentTime - lastCheckDate < 14400000) {
          if (this.vatInputAccount)
            this.renderMessage(this.data.shop.vatSaved, 'success');
          else this.renderMessage(this.data.shop.valid, 'success');
          return;
        }
      }
      try {
        const payload = {
          vat_id: value,
          customer: this.data.customer?.id,
          tax_exempt: this.data.customer.tax_exempt === 'true',
        };
        const res = await fetch(`${this.API_URL}/check-vat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data.valid) {
          window.localStorage.setItem('vat_id:last_check', new Date());
          console.log(this.vatInputAccount);
          console.log(this.data.shop.vatSaved);
          if (this.vatInputAccount)
            this.renderMessage(this.data.shop.vatSaved, 'success');
          else this.renderMessage(this.data.shop.valid, 'success');

          this.setHiddenInputValue(value);
        } else {
          this.setHiddenInputValue('');
          this.renderMessage(this.data.shop.invalid, 'error');
        }
      } catch (error) {
        this.renderMessage(this.data.shop.viesDown, '');
      }
    };

    // documentClickEventHandler = async (e) => {
    //   console.log('doc click');
    //   // if (e.target.form !== undefined) {
    //   console.log('doc click form');
    //   if (this.isCheckoutButton(e.target)) {
    //     console.log('doc click button');
    //     // remove last check on checkout button click to make sure tax exemption is removed on customer
    //     this.checkoutButtonClick();
    //   }
    //   // }
    // };

    checkoutButtonClick = async (e) => {
      console.log('checkout CLick');
      window.localStorage.removeItem('vat_id:last_check');
      this.checkoutButton()?.classList.add('working');
    };

    // documentClickEventHandler = async (e) => {
    //   if (e.target.form !== undefined) {
    //     if (this.isCheckoutButton(e.target)) {
    //       const value = this.vatInput?.value.replace(/\s/g, '').toUpperCase();
    //       if (!value) return;

    //       e.preventDefault();
    //       e.stopPropagation();

    //       console.log(value);
    //       console.log(e.target);

    //       const { form } = e.target;

    //       // start loading
    //       // this.startLoading(e.target);

    //       const payload = { vat_id: value };
    //       try {
    //         const res = await fetch(`${this.API_URL}/check-vat`, {
    //           method: 'POST',
    //           headers: {
    //             'Content-Type': 'application/json',
    //           },
    //           body: JSON.stringify(payload),
    //         });
    //         const data = await res.json();

    //         if (data.valid) {
    //           this.renderMessage(this.data.shop.valid, 'success');
    //           let baseUrl = window?.Shopify?.routes?.root;

    //           if (baseUrl === undefined || baseUrl === null) {
    //             baseUrl = '/';
    //           }
    //           this.setHiddenInputValue(value);
    //           // form.action = `${baseUrl}checkout?step=contact_information`;
    //           // form.submit();
    //         }
    //       } catch (error) {
    //         console.error(error);
    //       }
    //     }
    //   }
    // };

    isCheckoutButton = (target) => {
      if (target.form) {
        const action = target.form.getAttribute('action');
        if (action.search(/^\/checkout\b/) !== -1) {
          return true;
        }
        if (
          action.search(/^\/cart\b/) !== -1 &&
          target.getAttribute('name') === 'checkout'
        ) {
          return true;
        }
        if (
          action.search(/\/[a-zA-Z]{2}(-[a-zA-Z]{2})?\/cart/) !== -1 &&
          target.getAttribute('name') === 'checkout'
        ) {
          return true;
        }
        const path = this.getPath(action);
        if (path.search(/^\/checkout\b/) !== -1) {
          return true;
        }
        if (
          path.search(/^\/cart\b/) !== -1 &&
          target.getAttribute('name') === 'checkout'
        ) {
          return true;
        }
        if (
          path.search(/\/[a-zA-Z]{2}(-[a-zA-Z]{2})?\/cart/) !== -1 &&
          target.getAttribute('name') === 'checkout'
        ) {
          return true;
        }
      }
      return false;
    };
  }
);
